import { useInView } from "react-intersection-observer";
import { useLocation, useNavigate } from "react-router";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import { getGAData } from "@routes/Article/utils/helpers";
import { FeedArticleData } from "@routes/Article/utils/types";
import { getEnvironment } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";
import posthog from "posthog-js";

export const useHookUpdateUrlArticle = (
  urlPath: string,
  isNavigate: boolean,
  article: FeedArticleData,
  isChinese: boolean,
  variant?: string,
  setArticleObj?: (article: FeedArticleData) => void
) => {
  const sendDataToGTM = useSendDataToGTM();
  const navigate = useNavigate();
  const { search } = useLocation();
  const newUrl = urlPath + search;

  const { ref } = useInView({
    threshold: 0.01,
    onChange: (inView) => {
      if (typeof window === "undefined") return;
      if (!inView || !isNavigate || !article?.id) return;

      if (typeof setArticleObj === "function") setArticleObj(article);

      navigate(newUrl, { preventScrollReset: true });

      sendDataToGTM({
        ...window._data,
        ...getGAData(article, isChinese),
        abVariant: variant || "control",
        virtual_url: newUrl,
        event: "virtual_pv",
      });

      // For PostHog tracking
      const currentUrl = getEnvironmentDomain(getEnvironment()) + newUrl;
      posthog.capture("$pageview", {
        $pathname: newUrl,
        $current_url: currentUrl,
      });
    },
  });

  return { ref };
};
